import { STATUS_LABELS } from '@/data/integrations'
import type { IntegrationStatus } from '@/data/integrations'

/**
 * Status is a factual claim, not decoration — see the claims discipline note in
 * `data/integrations.ts`. Colours are deliberately muted so a "roadmap" chip
 * reads as information rather than as a downgrade.
 *
 * Semantic roles only (`--color-success` / `-warning` / `-info` in index.css),
 * never a framework scale like `emerald-500` — the theme owns the literal, and
 * scripts/ci/no-hardcode-guard.mjs enforces it on the PR diff.
 */
const STATUS_CLASSES: Record<IntegrationStatus, string> = {
  live: 'bg-success/10 text-success border-success/30',
  launching: 'bg-warning/10 text-warning border-warning/30',
  planned: 'bg-info/10 text-info border-info/30',
  request: 'bg-muted text-muted-foreground border-border',
}

export function IntegrationStatusChip({ status }: { status: IntegrationStatus }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_CLASSES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  )
}
